export default function () {
  let footer = document.querySelector('.footer__bottom')
  let scrollToTopBtn = document.querySelector('.back-to-top')
  let hideButtonClass = 'back-to-top--hidden'
  let dockedButtonClass = 'back-to-top--docked'
  let timer = null

  if (scrollToTopBtn) {
    document.addEventListener('scroll', function () {
      scrollToTopBtn.classList.remove(hideButtonClass)

      if (timer !== null) {
        clearTimeout(timer)
      }

      if (!scrollToTopBtn.classList.contains(dockedButtonClass)) {
        timer = setTimeout(function () {
          scrollToTopBtn.classList.add(hideButtonClass)
        }, 2000)
      }
    }, false)
  }

  function callback (entries, observer) {
    // The callback will return an array of entries, even if you are only observing a single item
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        scrollToTopBtn.classList.add(dockedButtonClass)
        scrollToTopBtn.classList.remove(hideButtonClass)
      } else {
        scrollToTopBtn.classList.remove(dockedButtonClass)
      }
    })
  }

  if (footer) {
    let observer = new IntersectionObserver(callback)
    observer.observe(footer)
  }
}
